import React from "react";
import PropTypes from "prop-types";

import "./DiscountBadge.css";

/*
  Pastille de remise réutilisable (TICK00276).
  Reprend les couleurs des pastilles de FinalPage (.printDiscountREMISEWEBSPAN /
  .printDiscountQUALIREPARSPAN) sans leurs marges négatives.
  variant : "bleu" (remise web) | "vert" (QualiRépar)
*/
export default function DiscountBadge(props) {
  const variant = props.variant === "vert" ? "discount-badge-vert" : "discount-badge-bleu";
  return (
    <span className={"discount-badge " + variant}>
      {props.label}
    </span>
  );
}

DiscountBadge.propTypes = {
  label: PropTypes.string,
  variant: PropTypes.string
};
